import React from 'react';
import clsx from 'clsx';
import styles from './ProgressStepper.module.scss';
export const ProgressStepper = ({ title, steps, currentStep, handleClick, complete = false, completeSteps = [], }) => {
    const previousSteps = [];
    for (const step of steps) {
        if (!complete && step.step === currentStep)
            break;
        previousSteps.push(step.step);
    }
    const handleStepperClick = (step) => {
        if (!complete && (previousSteps.includes(step) || completeSteps.includes(step)))
            handleClick(step);
    };
    return (<div className={styles.wrapper}>
      {title && <h3 className={styles.stepperTitle}>{title}</h3>}
      <div className={styles.stepperWrapper}>
        {steps.map((step) => (<div key={step.step} className={clsx(styles.stepWrapper, !complete && step.step === currentStep && styles.currentStep, !complete &&
                (previousSteps.includes(step.step) || completeSteps.includes(step.step)) &&
                styles.previousStep, complete && styles.completeStep)} onClick={() => handleStepperClick(step.step)}>
            <div className={styles.stepProgressBar}></div>
            <span className={styles.stepLabel}>{step.label}</span>
          </div>))}
      </div>
    </div>);
};
